// To parse this data:
//
//   import { Convert } from "./file";
//
//   const proyectosLoteListaPrecios = Convert.toProyectosLoteListaPrecios(json);

export class ProyectosLoteListaPrecios {
    id:number = 0;
    idProyecto: number;
    idListaPrecio: number;
    idModelo: number;
    incremento: number;
    numeroDeLista: number;
    algoritmo: number;
    unidadesMinimas: number;
    unidadesMaximas: number;
    estatus: number;
    tipo: string;
    nombreModelo: string;
    fechaHoraUM: Date;
    idUsuarioUM: number;
    nombreProyecto:string = "";
    checkedIncremento:boolean = false;
}

// Converts JSON strings to/from your types
export class Convert {
    public static toProyectosLoteListaPrecios(json: string): ProyectosLoteListaPrecios[] {
        return JSON.parse(json);
    }

    public static proyectosLoteListaPreciosToJson(value: ProyectosLoteListaPrecios[]): string {
        return JSON.stringify(value);
    }
}
